export const authConst = {
  internalHosts: ['localhost', 'sts-int.roboteon.com', 'sts-dev.roboteon.com'],
};
